export enum EAtoZEventBusActionTypes {
  CLOSE = 'aToZClose'
}
